import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Target = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12,3.99999995 C12.3418906,3.99999995 12.6236714,4.25736008 12.6621815,4.5889192 L12.6666667,4.66666662 L12.6669433,5.36627759 C15.8163321,5.67910005 18.3208999,8.18366789 18.6337224,11.3330567 L19.3333334,11.3333333 C19.7015232,11.3333333 20.0000001,11.6318102 20.0000001,12 C20.0000001,12.3418906 19.7426399,12.6236714 19.4110808,12.6621815 L19.3333334,12.6666667 L18.6337224,12.6669433 C18.3208999,15.8163321 15.8163321,18.3208999 12.6669433,18.6337224 L12.6666667,19.3333334 C12.6666667,19.7015232 12.3681898,20.0000001 12,20.0000001 C11.6581094,20.0000001 11.3763286,19.7426399 11.3378185,19.4110808 L11.3333333,19.3333334 L11.3330567,18.6337224 C8.18366789,18.3208999 5.67910005,15.8163321 5.36627759,12.6669433 L4.66666662,12.6666667 C4.29847679,12.6666667 3.99999995,12.3681898 3.99999995,12 C3.99999995,11.6581094 4.25736008,11.3763286 4.5889192,11.3378185 L4.66666662,11.3333333 L5.36627759,11.3330567 C5.67910005,8.18366789 8.18366789,5.67910005 11.3330567,5.36627759 L11.3333333,4.66666662 C11.3333333,4.29847679 11.6318102,3.99999995 12,3.99999995 Z M12,6.66666663 C9.05448132,6.66666663 6.66666663,9.05448132 6.66666663,12 C6.66666663,14.9455187 9.05448132,17.3333334 12,17.3333334 C14.9455187,17.3333334 17.3333334,14.9455187 17.3333334,12 C17.3333334,9.05448132 14.9455187,6.66666663 12,6.66666663 Z M12,8.66666665 C13.8409492,8.66666665 15.3333334,10.1590508 15.3333334,12 C15.3333334,13.8409492 13.8409492,15.3333334 12,15.3333334 C10.1590508,15.3333334 8.66666665,13.8409492 8.66666665,12 C8.66666665,10.1590508 10.1590508,8.66666665 12,8.66666665 Z M12,9.99999999 C10.8954305,9.99999999 9.99999999,10.8954305 9.99999999,12 C9.99999999,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,9.99999999 12,9.99999999 Z"
        id="path-1-target"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/maps/location-target/line">
        <mask id="mask-2-target" fill="white">
          <use xlinkHref="#path-1-target"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-target"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-target)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
